import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useDownloadTableModal } from '../context/DownloadTableModalContext';

const DownloadTableModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useDownloadTableModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('DownloadListing')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default DownloadTableModalHeader;
